export default __webpack_public_path__ + "static/media/chartsix.9e0cd1be.jpg";